const BaseTrackingId = 'global-location-picker';

export const LocationPickerTrackingIds = {
  searchFilters: (label: string) => `${BaseTrackingId}-search-filters-${label}-btn`,
  searchGroup: `${BaseTrackingId}-search-group-radio`,
  mainGroup: `${BaseTrackingId}-main-group-radio`,
  backToMainView: `${BaseTrackingId}-back-to-main-view-btn`,
  search: `${BaseTrackingId}-search-btn`,
  selectAll: (label: string) => `${BaseTrackingId}-${label}-select-all--btn`,
  deselectAll: (label: string) => `${BaseTrackingId}-${label}-select-all--btn`,
};
